import { render, staticRenderFns } from "./warehouseTwo.vue?vue&type=template&id=0801c180&scoped=true&"
import script from "./warehouseTwo.vue?vue&type=script&lang=js&"
export * from "./warehouseTwo.vue?vue&type=script&lang=js&"
import style0 from "./warehouseTwo.vue?vue&type=style&index=0&id=0801c180&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801c180",
  null
  
)

export default component.exports